import { JSONSchema6 } from "json-schema";

const getBuyerSchema: JSONSchema6 = {
    title: "Get Buyer",
    description: "Get Buyer will only return buyerId by default. You must explicitly request access to additional buyer details using the button signInScopes parameter. Amazon Pay will only provide the token required to retrieve buyer details after the buyer signs in. It will be appended to the signInReturnUrl as a query parameter and expires after 24 hours.",
    properties: {
        "pathParam": {
            title: "buyerToken",
            type: "string",
            maxLength: 1024
        }
    },
    required: ["pathParam"]
}

export default getBuyerSchema
